import { Facebook, Instagram, Phone } from "lucide-react";
import { LOCATIONS, SOCIAL_LINKS } from "../lib/content";

const ICONS = { Facebook, Instagram };

/** Top utility strip: both marina phone numbers (click-to-call everywhere) and
 *  the marina's real social accounts. Mirrors the live site's structure. */
export const UtilityBar = () => (
  <div data-testid="utility-bar" className="border-b border-white/10 bg-navy-surface/80">
    <div className="mx-auto flex max-w-[88rem] flex-wrap items-center justify-between gap-x-6 gap-y-1 px-4 py-2 lg:px-8">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
        {Object.values(LOCATIONS).map((loc) => (
          <a
            key={loc.slug}
            href={loc.phoneHref}
            data-testid={`utility-call-${loc.slug}`}
            className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-white/75 transition-colors hover:text-white"
          >
            <Phone className="h-3.5 w-3.5 shrink-0 text-lake" aria-hidden="true" />
            <span>
              Call {loc.name.replace(" Boat Rentals", " Marina")} :{" "}
              <span className="font-bold text-white/90">{loc.phone}</span>
            </span>
          </a>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-[12px] font-semibold text-white/60">Follow Us on :</span>
        {SOCIAL_LINKS.map((s) => {
          const Icon = ICONS[s.label];
          return (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              aria-label={s.label}
              data-testid={`utility-social-${s.label.toLowerCase()}`}
              className="inline-flex h-7 w-7 items-center justify-center rounded-full text-white/75 transition-colors hover:bg-white/10 hover:text-white"
            >
              <Icon className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
          );
        })}
      </div>
    </div>
  </div>
);

export default UtilityBar;
